import script from "./ManagementFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementFilters.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementFilters.vue?vue&type=style&index=0&id=47fb6ec5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47fb6ec5"]])

export default __exports__